import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import useLeaderState from "@hooks/useLeaderState";
import { scale, verticalScale } from "../../utils/scale";
import color from "../../constants/color";
import Cross from "../../assets/svg/Cross";
import RightArrow from "../../assets/svg/RightArrow";

const PATH = "screens/Home/CartBottomStrip";

function CartBottomStrip({
  orderClick,
  isSearch,
  bottom,
  onCrossClick,
  name,
  item,
  total,
  askForLocation = true,
  force_allow_payment = false,
}) {
  const navigation = useNavigation();
  const { pincode, city, address1 } = useSelector(({ auth: { user } }) => user);
  const { canLeaderUseApp } = useLeaderState();
  const isLeaderHavingAddress = () => {
    return address1 !== null;
  };

  const handlePlaceOrder = () => {
    let can_payment = true;
    if (force_allow_payment) {
      can_payment = true;
    }
    if (!canLeaderUseApp(true) && !can_payment) {
      can_payment = false;
    }
    if (!can_payment) {
      return;
    }
    if (!isLeaderHavingAddress() && askForLocation) {
      navigation.navigate("TLAddress", {
        fromPlaceOrder: true,
        pincode,
        city,
        source: "cart_bottom_strip",
      });
      return;
    }
    orderClick();
  };

  return (
    <View
      style={[
        styles.beLikeRow,
        isSearch ? styles.addAddressStrip1 : styles.addAddressStrip,
        bottom,
      ]}
    >
      <TouchableOpacity
        testID="cbs-cross"
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        onPress={onCrossClick}
        style={{
          height: scale(28),
          width: scale(27),
        }}
      >
        <View style={styles.crossContainer}>
          <Cross />
        </View>
      </TouchableOpacity>
      <View
        style={{
          backgroundColor: "#C90022",
          justifyContent: "space-between",
          height: scale(40),
        }}
      >
        <Text
          style={{
            color: "#fff",
            marginLeft: scale(15),
            fontSize: scale(14),
            fontWeight: "600",
          }}
        >
          {name}
        </Text>
        {!item ? (
          <Text
            style={{
              color: "#fff",
              marginLeft: scale(15),
              fontSize: scale(16),
              fontWeight: "600",
            }}
          >
            0 {t(`${PATH}/items`)}
          </Text>
        ) : (
          <Text
            style={{
              color: "#fff",
              marginLeft: scale(15),
              fontSize: scale(16),
              fontWeight: "600",
            }}
          >
            {item} {t(`${PATH}/items`)}{" "}
            <Text style={{ fontWeight: "bold" }}>• ₹</Text>
            {total}{" "}
          </Text>
        )}
      </View>

      {!item ? (
        <View
          style={{
            height: verticalScale(40),
            flexDirection: "row",
            top: verticalScale(6),
            borderRadius: scale(6),
            backgroundColor: color.white,
            alignItems: "center",
            position: "absolute",
            right: scale(15),
            paddingHorizontal: 10,
          }}
          onPress={handlePlaceOrder}
        >
          <Text
            style={{
              color: "rgba(0, 0, 0, 0.36)",
              textAlign: "center",
              fontSize: scale(16),
              lineHeight: scale(20),
              paddingHorizontal: 10,
            }}
          >
            {t(`${PATH}/placeOrder`)}
          </Text>
          <RightArrow />
        </View>
      ) : (
        <TouchableOpacity
          testID={testIds.Order_Kre_Bottom_Strip}
          style={{
            height: verticalScale(40),
            flexDirection: "row",
            top: verticalScale(7),
            borderRadius: scale(6),
            backgroundColor: color.white,
            alignItems: "center",
            position: "absolute",
            right: scale(15),
            paddingHorizontal: 10,
          }}
          onPress={handlePlaceOrder}
        >
          <Text
            style={{
              color: "rgba(0, 0, 0, 0.86)",
              textAlign: "center",
              fontSize: scale(16),
              lineHeight: scale(20),
              fontWeight: "bold",
              paddingHorizontal: 10,
            }}
          >
            {t(`${PATH}/placeOrder`)}
          </Text>
          <RightArrow />
        </TouchableOpacity>
      )}
    </View>
  );
}

export default CartBottomStrip;

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    backgroundColor: "#C90022",
    width: "100%",
  },
  crossContainer: {
    justifyContent: "center",
    alignItems: "center",

    height: scale(20),
    width: scale(20),
    borderRadius: scale(100),
    backgroundColor: "#fff",
  },
  addAddressStrip: {
    height: scale(52),
    borderTopLeftRadius: scale(10),
    borderTopRightRadius: scale(10),
    position: "absolute",
    backgroundColor: "#C90022",
    paddingHorizontal: 5,
    paddingVertical: verticalScale(7),
    width: "100%",
    bottom: 0,
  },
  addAddressStrip1: {
    height: scale(52),
    borderTopLeftRadius: scale(10),
    borderTopRightRadius: scale(10),
    position: "absolute",
    backgroundColor: "#C90022",
    paddingHorizontal: 5,
    paddingVertical: verticalScale(7),
    width: "100%",
    bottom: 50,
  },
});
